import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'reactstrap';
import { TextRupiah } from '../../../Text';
import PropTypes from 'prop-types';
import KredivoTag from './KredivoTag';
import styled from "styled-components";
export default class PriceTag extends PureComponent{
  render(){
    return(
      <Row className="price buy-now">
        <Col className="price-col" sm={3} xs={4}>
          <BuyNowWrapper>
            <h4>{this.props.invoice?'Price': 'Buy Now'}</h4>
            <h4>-</h4>
          </BuyNowWrapper>
        </Col>
        <Col className="price-col" sm={9} xs={8}>
          <PriceWrapper subsidy={parseInt(this.props.total_subsidy) > 0}>
            <h4>
              <TextRupiah 
                value={this.props.total_subsidy && parseInt(this.props.total_subsidy) > 0? this.props.total_subsidy : this.props.asking_price}
                prefix="IDR. "
                color={this.props.total_subsidy && parseInt(this.props.total_subsidy) > 0? "red" : "default"}
                className="price-tag"
                align="center"
                bold={true}
              />
            </h4>
          </PriceWrapper>
        </Col>
      </Row>
    )
  }
}
// Pass installments from redux
PriceTag.propTypes={
    showInstallments: PropTypes.bool,
    box_condition:PropTypes.string,
    installments: PropTypes.object,
    asking_price:PropTypes.any
}
PriceTag.defaultProps={
    box_condition:'',
    asking_price:0,
    showInstallments:false
}

const BuyNowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  h4 {
    &:last-child{
      margin-left: 1rem;
    }
  }

  @media(max-width: 480px){
    h4 {
      &:first-child{
        margin-left: 15px;
      }
      &:last-child{
        margin-left: 1rem;
      }
    }
  }
`

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  h4{
    margin-left: -1rem;
  }

  @media(max-width: 480px){
    h4 {
      margin-left: 0.5rem;
    }
  }
`